import axios from "../../../context/axiosConfig";

const pozyczkiGeneratePromissoryPdf = async (loanId) => {
	return axios.post(
		"/pozyczki/promissory/pdf",
		{ loanId },
		{ responseType: "blob" },
	);
};

export default pozyczkiGeneratePromissoryPdf;
